var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"complain-effect",on:{"click":function($event){return _vm.redirect()}}},[_c('i',{staticClass:"custom-icon icon-complain-adv mini"}),_c('span',{staticClass:"text slide-left"},[_vm._v(_vm._s(_vm.$t("CLICK_TO_COMPLAIN")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }